export enum MergeDocumentsStatus {
  MERGE_INITIATED = 'Merge_Initiated',
  MERGE_PROGRESS = 'Merge_Progress',
  MERGING_DOCUMENT = 'Merging_Document',
  GENERATING_BOOKMARKS = 'Generating_Bookmarks',
  UPLOADING_DOCUMENTS = 'Uploading_Document',
  MERGE_COMPLETED = 'Merge_Completed',
  MERGE_ERROR = 'Merge_Error'
}
